import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { FilePenLine } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import { PeriodicReviewProgressStep, useProgress } from '@/context/progress';
import { PERIODIC_REVIEW_PATHS } from '@/features/periodic-review/constants';
import BaseLayout from '@/layouts/base';

const PeriodicReviewPage = () => {
  const { setCurrentStep } = useProgress();
  const { t } = useTranslation();

  useEffect(() => {
    return setCurrentStep(PeriodicReviewProgressStep.PERIODIC_REVIEW_PERSONAL_INFORMATION, 0);
  }, [setCurrentStep]);

  return (
    <BaseLayout className="-md:justify-center space-y-8" size="sm">
      <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
        <FilePenLine />
      </GradientIcon>
      <PageHeading centered>
        <PageHeadingTitle>{t('periodicReview.intro.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t('periodicReview.intro.description')}</PageHeadingDescription>
      </PageHeading>
      <footer className="flex flex-col gap-4">
        <Button size="lg" variant="primary" asChild>
          <Link to={PERIODIC_REVIEW_PATHS.PERSONAL_INFORMATION} replace>
            {t('buttons.continue')}
          </Link>
        </Button>
      </footer>
    </BaseLayout>
  );
};
PeriodicReviewPage.displayName = 'PeriodicReviewPage';

export default PeriodicReviewPage;
